import { render, staticRenderFns } from "./performance-template-item.vue?vue&type=template&id=5bfe683e"
import script from "./performance-template-item.vue?vue&type=script&lang=js"
export * from "./performance-template-item.vue?vue&type=script&lang=js"
import style0 from "./performance-template-item.vue?vue&type=style&index=0&id=5bfe683e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports